import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { updateSegment } from '../../../redux/currentSearch/actions';
import { getDateErrorSelector, getSegments, displayFaresInCalendar, getDateRangeConfig } from '../../../redux/currentSearch/selectors';
import { CurrentAccommodationSearchSessionStorage, DateUtils } from '../../../utils';
import { useSegmentContext } from './SegmentManager/Context';

export const SegmentDate = ({ children, segments, updateSegment, dateError, displayFaresInCalendar, maxDays, minDays }) => {
    const { segment } = useSegmentContext();
    const { id, date } = segment;
    const { min: minOffset, max: maxOffset } = useSelector((state) => getDateRangeConfig(state, { id }));
    const dates = segments.map((s) => DateUtils.stringToDate(s.date));

    const [minDate, setMinDate] = React.useState(DateUtils.calculateMinDateFromSegments(segments, id, minDays));
    const [maxDate, setMaxDate] = React.useState(DateUtils.calculateMaxDateFromSegments(segments, id, maxDays));


    const setValue = (date) => {
        updateSegment({ date }, id);
        CurrentAccommodationSearchSessionStorage.setDates({ id, date, segments });
    };


    React.useEffect(() => {
        const minDate = DateUtils.calculateMinDateFromSegments(segments, id, minDays);
        const maxDate = DateUtils.calculateMaxDateFromSegments(segments, id, maxDays);
        const minDateWithOffset = DateUtils.add(minDate, minOffset);
        setMinDate(minDateWithOffset);
        setMaxDate(maxOffset ? DateUtils.add(minDate, maxOffset) : maxDate);
    }, [id, maxDays, maxOffset, minDays, minOffset, segments]);

    React.useEffect(() => {
        if (date && DateUtils.compare(DateUtils.stringToDate(date), DateUtils.stringToDate(minDate)) === 1) {
            updateSegment({ date: null }, id);
        }
    }, [date, id, minDate, updateSegment]);

    React.useEffect(() => {
        if (date && DateUtils.compare(DateUtils.stringToDate(maxDate), DateUtils.stringToDate(date)) === 1) {
            updateSegment({ date: null }, id);
        }
    }, [date, id, maxDate, updateSegment]);

    return children({ error: dateError, dates, minDate, maxDate, setValue, value: date, displayFaresInCalendar });
};

SegmentDate.propTypes = {
    children: PropTypes.func.isRequired,
    updateSegment: PropTypes.func.isRequired,
    displayFaresInCalendar: PropTypes.bool.isRequired,
    maxDays: PropTypes.number,
    minDays: PropTypes.number,
};
SegmentDate.defaultProps = {
    maxDays: -1,
    minDays: 0
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
    dateError: getDateErrorSelector,
    displayFaresInCalendar,
});

export const ConnectedSegmentDate = connect(mapStateToPropsSelector, {
    updateSegment,
})(SegmentDate);
